import React from 'react';

export const CompleteBanner = (): JSX.Element => {
  return (
    <>
      <div className="u-els-text-center">
        <div className="u-els-font-size-h2">
          <span role="img" aria-label="party popper">&#127881;</span>
        </div>
        <div className="u-els-font-size-h2">Congratulations!</div>
        <div className="u-els-font-size-h4">All required work for your plan is complete!</div>
      </div>
      <div className="o-els-container o-els-container--2x c-els-divider" />
    </>
  )
}
